export default __webpack_public_path__ + "static/batdongsan-466a8e46717d73721e41544b01598068.jpg";